module.exports = "data:image/webp;base64,UklGRngBAABXRUJQVlA4IGwBAAAwBwCdASoZABkAPpFAm0olo6IhqAgAsBIJZQC3vrSW4Ov03xeZ36A6Zn1jeSAHTMsEKzjFnB7gb6OoU+Mne28viAAA/s95+tFtpUsCgAK1klNkdPCoag0JLHeaeGdbK7vW2Aezf6ByYQvwZp6iBsf4yGK2DrkK8U/wgnWdNxjAY8zD7AipxgrWbbAYMKhWIGmn5TaivnmEtp/ryGauGn3Z2i0xx/LOb8gXZ/NLZJZrFtqfVpL0nOAEPTvBQ0vZjRwy+Efi70EjLirKJTFm4eyyrdV46uazeLSznm9qLOj5UX7x+1ZifyeL7a2lcSf/TAvSg/VYa+TW1RBv3/uY+P+fkheLHeh40TGiCz/TP0DrWjA+dBRPttU8PDjhDgX58bx+Yqeo9nS2es8T/z2EqC76x8ZlM61y+XAutFwOQMk44WbP019m9I/WHycvvqqlp1pue3GEj2UjYJawGtE3E7iv/mpiCNCmEVlbAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/blue_wash.webp
// module id = bdtn
// module chunks = 14